export const OpenIMConfig = {
    platformId: 5,
    // Vendor servers (for development/testing, replace with actual addresses in production)
    //apiAddr: 'https://im.vigo-global.com/api',
    //wsAddr: 'wss://im.vigo-global.com/msg_gateway',
    // KMS's dev servers (via nginx proxy to avoid CORS)
    apiAddr: 'https://chatopenimtest.jfc.com/openim',
    wsAddr: 'wss://chatopenimtest.jfc.com/msg_gateway',
};

// JFC Chat API for authentication
export const JFCChatConfig = {
    // Vendor servers (for development/testing, replace with actual addresses in production)
    //apiAddr: 'https://chat.vigo-global.com/api/v1',
    // KMS's dev servers (via nginx proxy to avoid CORS)
    apiAddr: 'https://chatapitest.jfc.com/api/v1',
    userRoleEndpoint: '/auth/user-role',
    usersTokenEndpoint: '/client/users/token',
    clientRoomsEndpoint: '/client/rooms',
    messageReadEndpoint: '/client/message/read',
};

// UI feature flags
export const UIConfig = {
    STICKERS_UI_ENABLED: false, // Temporarily hide Stickers UI.
};

// File upload configuration
export const FileConfig = {
    MAX_SIZE: 1024 * 1024 * 1024, // 1024MB in bytes
};

// Klipy GIF API configuration
export const KlipyConfig = {
    API_BASE: 'https://api.klipy.com/api',
    API_KEY: '0hTDM8jHsfo6BefU3z4nfXvg8M8WELRiO0c21hH0DriSZIJookwbFPkz4A6qPlW2',
};

// Firebase Cloud Messaging configuration
// VAPID key from Firebase Console -> Project Settings -> Cloud Messaging -> Web Push certificates
export const FirebaseConfig = {
    //VAPID_KEY: 'BI3wPt2FZVDqbygGfXLTXxjmG1-Hkzgj6wt_RBElHkwppDQFGpaE88YJPUxbzjbF98ev3fsXGbk4DRc0Lr_1MUE',
    //KMS Firebase key
    VAPID_KEY: 'BCyx5vnqiXbK4_HZWvi346QGLQGTvzVs-5nwjj_QdfB-Qc_mBP9qQTEtDSDRsh8yvvKq1qO6SKe_AJB14ze-wcM',
};

// Message configuration
export const MessageConfig = {
    REVOKE_TIME_LIMIT_MS: 2 * 60 * 1000, // 2 minutes in milliseconds
};
